var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "div",
        { staticClass: "notification-list" },
        _vm._l(_vm.getNotificationList, function(notification) {
          return _c(
            "div",
            {
              key: notification.id,
              staticClass: "notification",
              class: notification.type ? "--" + notification.type : ""
            },
            [
              _c("h2", { staticClass: "notification__headline" }, [
                _vm._v(_vm._s(notification.title))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "notification__text" }, [
                _vm._v(_vm._s(notification.message))
              ]),
              _vm._v(" "),
              notification.confirm
                ? _c(
                    "button",
                    {
                      staticClass: "notification__ok",
                      attrs: { tabindex: "0" },
                      on: {
                        click: function($event) {
                          return _vm.dismissNotification(notification.id)
                        }
                      }
                    },
                    [_vm._v("\n        OK\n      ")]
                  )
                : _vm._e()
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.getIsLoadedState ? [_c("router-view")] : _c("Loading")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 